import { Loader } from '@progress/kendo-react-indicators'

interface IProps {
  message?: string
}

/**
 * Spinner centrado que cubre el contenedor posicionado más cercano.
 * Para grids usar LoadingGrid; para operaciones largas LoadingModal;
 * para carga inline con mensaje LoadingSmall.
 */
export const Loading: React.FC<IProps> = ({ message }) => {
  return (
    <div
      className="!k-d-flex !k-flex-col !k-justify-content-center !k-align-items-center !k-gap-4"
      style={{ position: 'absolute', inset: 0, minHeight: '120px' }}
    >
      <Loader type="infinite-spinner" size="large" themeColor="primary" />
      {message && <small className="!k-text-subtle">{message}</small>}
    </div>
  )
}
